// extracted by mini-css-extract-plugin
export var aboutContainer = "basicPage-module--aboutContainer--V0u1d";
export var basicImg = "basicPage-module--basicImg--zPsjp";
export var container = "basicPage-module--container--j-IHt";
export var containerGrid = "basicPage-module--containerGrid--NKyRa";
export var section = "basicPage-module--section--qWRi+";